module.exports = __webpack_public_path__ + "static/nutrition_bottom_bar_layout-d78612a9e6dec93d438fdbe8db9c234c.png";